export enum Billing {
    CREDIT = 'credit',
    PROFIT = 'profit',
    EXPENSE = 'expense',
    DISCOUNT = 'discount'
}